import {
  Collision,
  CollisionDetection,
  DroppableContainer,
  rectIntersection,
} from "@dnd-kit/core";
import { WINDOW_PROPERTY_SORT_POSITION } from "./utils";

const collisionDetection: CollisionDetection = (args) => {
  // This is NOT a keyboard event
  if (args.pointerCoordinates !== null) {
    return rectIntersection(args);
  }

  const { droppableContainers } = args;

  const matchedDroppable = droppableContainers.find(
    (container) =>
      container.id ===
      (window[WINDOW_PROPERTY_SORT_POSITION] ?? args.active.id),
  );

  if (matchedDroppable)
    return getCollisions(matchedDroppable, droppableContainers);
  return [];
};

/**
 * Gets collisions for the current droppable container -- that is, the container and its zone.
 * @param currentDroppable The current droppable container
 * @param allDroppables An array of all droppable containers
 * @returns
 */
const getCollisions = (
  currentDroppable: DroppableContainer,
  allDroppables: DroppableContainer[],
) => {
  const collisions: Collision[] = [];

  collisions.push({
    id: currentDroppable.id,
    data: { droppableContainer: currentDroppable, value: 1 },
  });

  const currentZoneId = currentDroppable.data.current?.zone?.id;
  const currentZone = allDroppables.find(
    (container) => container.id === currentZoneId,
  );
  if (currentZone) {
    collisions.push({
      id: currentZone.id,
      data: {
        droppableContainer: currentZone,
        value: 1,
      },
    });
  }
  return collisions;
};

export default collisionDetection;
